/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2020-8-7 15点16分
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2020-8-7 15点16分
 */

const state = {
  articleList: []
}

const actions = {
  set_articleList(context, option) {
    context.commit('set_articleList', option)
  }
}

const getters = {}

const mutations = {
  set_articleList(state, option) {
    if (!state.articleList || option.data.length === 0 || parseInt(option.message) === 101) {
      state.articleList = []
    }
    state.articleList.push(...option.data)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/circle/articleList.js